import EmptyProposal from './EmptyProposal';

export default EmptyProposal;
